<div>
  <kl-network-author-details [author]="notification?.author" [isConnected]="false" avatarSize="md">
  </kl-network-author-details>
</div>
